<template>
  <page-banner :pageNumber='5' pageName="fixed"></page-banner>
  <div class="center">
    <div class="mainContainer">
      <div v-for="(item,index) in centerManage" :key="index" :class="item.class" @click="centerManageClick(item)">
        <img :src="`/ywtx/${item.imgSrc}.png`" alt="">
        <span class="font">{{item.name}}</span>
      </div>
    </div>
  </div>
  <div class="mainContainer content">
    <div class="manage">
      <div v-for="(item,index) in contentManage" :key="index" :class="item.class" @click="contentManageClick(item)">
        {{item.name}}
      </div>
    </div>
    <div class="underContentDetails" v-if="contentType === 2 || contentType === 1">
      <div class="data">
        <nuxt-link :to="`/ywtx/xq/${item.id}?from=/ywtx/gcjs`" class="details" v-for="(item,index) in contentDetails" :key="index">
          <div class="cover">
            <img :src="baseUrl+item.contentTitleCover" alt="">
            <div class="model" v-if="item.content">{{item.content}}</div>
          </div>
          <div class="titleAll">
            <div class="left">
              <div class="titleBig">
                {{item.contentTitle}}
              </div>
              <div class="titleSmil">
                {{item.content}}
              </div>
            </div>
            <div class="right"></div>
          </div>
        </nuxt-link>
      </div>
      <pagination :total="pramas.total" @changePage="handleRefresh" :pageSize="pramas.pageSize" :page = 'pramas.page' :key="contentType"/>
    </div>
    <div class="Innovation" v-if="contentType === 3 || contentType === 4">
      <div class="data">
        <nuxt-link :to="`/ywtx/xq/${item.id}?from=/ywtx/gcjs`" class="detailsAll" v-for="(item,index) in contentDetails" :key="index">
          <div class="detailsFont">
            <div class="time">
              <div class="date">{{dayjs(item.createTime).format('D')}}</div>
              <div class="years">{{dayjs(item.createTime).format('YYYY-MM')}}</div>
            </div>
            <div class="content">
              {{item.contentTitle}}
            </div>
          </div>
          <div>
            <div class="icon"></div>
          </div>
        </nuxt-link>
      </div>
      <pagination :total="pramas.total" @changePage="handleRefresh" :pageSize="pramas.pageSize"  :page = 'pramas.page' :key="contentType"/>
    </div>
  </div>
</template>

<script setup>
  import {findEngineeringProjects, findGWEngineeringProjectDetails} from "../../apis/ywtx.js";
  import dayjs from 'dayjs'

  const baseUrl = import.meta.env.VITE_FILE_HOST
  const centerManage = ref([{
      name: '工程建设',
      class: 'btnbox buttonClick',
      // imgSrc: getImageUrl('gcjsWhite.png'),
      imgSrc: 'gcjsWhite',
      path: '/ywtx/gcjs'
    },
    {
      name: '科教文化',
      class: 'btnbox button',
      // imgSrc: getImageUrl('kjwhBlack.png'),
      imgSrc: 'kjwhBlack',
      path: '/ywtx/kjwh'

    },
    {
      name: '资本运作',
      class: 'btnbox button',
      // imgSrc: getImageUrl('zbyzBlack.png'),
      imgSrc: 'zbyzBlack',
      path: '/ywtx/zbyz'
    },
    {
      name: '城市发展',
      class: 'btnbox button',
      // imgSrc: getImageUrl('csfzBlack.png'),
      imgSrc: 'csfzBlack',
      path: '/ywtx/csfz'
    }
  ])
  const contentManage = ref([{
      name: '在建(监)项目',
      class: 'btnbox buttonClick',
      type: 2
    },
    {
      name: '精品工程',
      class: 'btnbox button',
      type: 1
    },
    {
      name: '科技创新',
      class: 'btnbox button',
      type: 3
    },
    {
      name: '项目开发',
      class: 'btnbox button',
      type: 4
    }
  ])
  
  const contentDetails = ref([])
  const button = ref()
  const Router = useRouter();
  const centerManageClick = (item) => {
    Router.push(item.path)
    centerManage.value.forEach(res => {
      if (res.name === item.name) {
        res.class = 'btnbox buttonClick'

      } else {
        res.class = 'btnbox button'
      }
    })
  }
  //点击子菜单
  const contentType = ref(2);
  const pramas = ref({
    total: 0,
    page: 1,
    pageSize: 12,
    contentTypeId: 2
  })


  /**
   * @description: 获取工程建设信息
   * */
    const axios = ref(findGWEngineeringProjectDetails({...pramas.value}))
    const engineeringRes = await useAsyncData('findEngineeringProjects233', () => axios.value)
  //   const engineeringRes = await useAsyncData('findEngineeringProjects233', () => axios.value,{ watch: [pramas.value] })
    if (engineeringRes.data.value.code !== 200) {
      throw createError({
        statusCode: engineeringRes.data.value.code,
        statusMessage: encodeURIComponent("获取工程建设信息失败")
      })
    } else {
      pramas.value.total = engineeringRes.data.value.data.total
      contentDetails.value = engineeringRes.data.value.data.list
    }
// 点击小标题 切换菜单和获取对应新数据
  const contentManageClick = (item) => {
    contentType.value = item.type
    pramas.value.contentTypeId = item.type
    pramas.value.total = 0
    handleRefresh(1)
    contentManage.value.forEach(res => {
      if (res.name === item.name) {
        res.class = 'btnbox buttonClick'
      } else {
        res.class = 'btnbox button'
      }
    })
  }
// 重新请求接口
  function handleRefresh(value) {
    pramas.value.page = value
    if(contentType.value === 3 || contentType.value === 4){
      pramas.value.pageSize = 20
      axios.value = findEngineeringProjects({...pramas.value})
    } else {
      pramas.value.pageSize = 12
      axios.value = findGWEngineeringProjectDetails({...pramas.value})
    }
    engineeringRes.refresh()
  }
  watch(engineeringRes.data, (newValue, oldValue) => {
      contentDetails.value = []
      contentDetails.value = engineeringRes.data.value.data.list
      pramas.value.total = engineeringRes.data.value.data.total
    }
  );

  useHead({
    title: `工程建设|业务体系 - 郑州路桥建设投资集团有限公司`,
  })
</script>

<style scoped lang="scss">
@import "ywtx";
</style>